import React from "react";
import ApprovePPOPending from "./approveChangePPOPending";
import ApprovePPOCompleted from "./approveChangePPOCompleted";
import ReviseChangePPOPending from "./reviseChangePPOPending";
import ReviseChangePPOCompleted from "./reviseChangePPOCompleted";
import ApproveChangePPOService from "../../../service/changePPO/ApproveChangePPOService";
import { actions } from "../../publicDictionaryValues";
import ProcessBase from "../../commonComponents/processBase";
import NormalSpin from "../../../base/basicComponents/spin";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";

import ApproveChangePPOStepService from "../../../service/changePPO/approveChangePPOStepService";
import StepService from "../../../service/stepBase/StepService";
import { disableInteraction, enableInteraction } from "utils";

export default class PrimaryProcedureOwner extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      pageHeadState: {
        receiveDate: null,
        requestByName: null,
      },
      procedureInfoState: {
        isPMPExcluded: null,
        procedureStatus: null,
        primaryProcedureOwner: null,
        procedureOwner: null,
        procedureNote: null,
        returnReasonLog: [],
        requestReasonLog: [],
      },
      rejectReason: null,

      pageType: "",
      primaryProcedureOwnerStepItem: {},
      isApprovedCompletedPage: false,
      isSubmittedCompletedPage: false,
      isReturnedCompletedPage: false,
      isRejectedCompletedPage: false,
      shareTask: null,
      procedureFileData: {
        procedureTableData: [],
        clientServerPath: null,
        savedInRadioValue: null,
      },
      supportingFileData: [],
      jbProcedureSavedIn: null,
      taskInformationData: [],
      stepItemData: null,
    };
    // @ts-ignore
    this.pageTypeEnums = {
      isApprovePending: "isApprovePending",
      isApproveCompleted: "isApproveCompleted",
      isRevisePending: "isRevisePending",
      isReviseCompleted: "isReviseCompleted",
    };
  }

  _showLoading = () => {
    disableInteraction();
    this.setState({ loading: true });
  };

  _hideLoading = async () => {
    await enableInteraction();
    this.setState({ loading: false });
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  returnReasonLog = (stepHistoryList: any) => {
    const returnReasonLog: any[] = [];
    stepHistoryList.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    stepHistoryList.forEach((item: any, index: any) => {
      if (item.actionID === actions.return) {
        returnReasonLog.push({
          key: index,
          returnedBy: item.auditedByName,
          returnDate: this._formateDate(item.modifiedDate),
          returnReasonColumn: item.returnReason,
        });
      }
    });
    return returnReasonLog;
  };

  requestReasonLog = (stepHistoryList: any) => {
    const requestReasonLog: any[] = [];
    stepHistoryList.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    stepHistoryList.forEach((item: any, index: any) => {
      if (item.actionID === actions.submit || item.actionID === actions.revise) {
        requestReasonLog.push({
          key: index,
          submittedBy: item.requestByName,
          submittedDate: this._formateDate(item.modifiedDate),
          reasonColumn: item.reason,
        });
      }
    });
    return requestReasonLog;
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      this.setProcedureTableData(result.procedureFolder);
      this.setState({
        procedureFileData: {
          savedInRadioValue:
            result.procedureFolder !== null
              ? result.procedureFolder.procedureSaveInCategoryID
              : null,
          clientServerPath:
            result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
          // @ts-ignore
          procedureTableData: this.procedureTableData,
        },
        // @ts-ignore
        supportingFileData: this.supportingTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
      });
    }
  };

  setShareTaskData = (result: any) => {
    if (result.shareTask === null || result.shareTask === undefined) {
      return;
    }

    this.setState({
      shareTask: result.shareTask,
    });
  };

  setSupportingFileData = (result: any) => {
    if (result.supportingFolder !== null) {
      this.setSupportingTableData(result);
      this.setState({
        // @ts-ignore
        supportingFileData: this.supportingTableData,
      });
    }
  };

  _getPrimaryProcedureOwnerStepItemSuccess = (response: any, flowDataResult: any) => {
    const result = { ...response, ...flowDataResult };
    const {
      actionID,
      primaryProcedureOwner,
      workflowProcessStepInfo,
      shareTask,
      procedureFolder,
      reviceDate,
      requestByName,
      procedureOwner,
      procedureNote,
      workflowProcessInstanceId,
      rejectReason,
      applyPmpExcluded,
      sequence,
      procedureStatusID,
      taskInfomation,
    } = result;
    const { procedureStepStatus, actionTaken } = primaryProcedureOwner;
    const isApprove =
      workflowProcessStepInfo.annotations.find((item: any) => (item.name = "IsRevise")).value ===
      "0";
    const isSubmit = sequence === 1;
    let pageType = "";
    if (procedureStepStatus === "Pending") {
      pageType = isApprove ? "isApprovePending" : "isRevisePending";
    } else if (procedureStepStatus === "Complete") {
      pageType = isApprove || isSubmit ? "isApproveCompleted" : "isReviseCompleted";
    }
    const isApprovedCompletedPage =
      actionTaken === "Approved" || actionTaken === "Automatically Approved";
    const isSubmittedCompletedPage = isSubmit;
    const isReturnedCompletedPage = actionID === actions.return;
    const isRejectedCompletedPage = actionID === actions.reject;
    this.setProcedureTableData(procedureFolder);
    this.setSupportingTableData(result);
    this.setState({
      pageType,
      primaryProcedureOwnerStepItem: result,
      isApprovedCompletedPage,
      isSubmittedCompletedPage,
      isReturnedCompletedPage,
      isRejectedCompletedPage,
      shareTask,
      jbProcedureSavedIn:
        result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
      pageHeadState: {
        receiveDate: this._formateDate(reviceDate),
        requestByName,
      },
      procedureInfoState: {
        isPMPExcluded: applyPmpExcluded?.isExcluded ? "Yes" : "No",
        procedureStatus: procedureStatusID,
        primaryProcedureOwner,
        procedureOwner,
        procedureNote,
        returnReasonLog: this.returnReasonLog(primaryProcedureOwner?.stepHistoryList),
        requestReasonLog: this.requestReasonLog(primaryProcedureOwner?.stepHistoryList),
        workflowProcessInstanceId,
      },
      procedureFileData: {
        savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
        clientServerPath:
          result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
        // @ts-ignore
        procedureTableData: this.procedureTableData,
      },
      // @ts-ignore
      supportingFileData: this.supportingTableData,
      stepItemData: result,
      taskInformationData: taskInfomation,
    });

    if (actionID === actions.reject && !!rejectReason) {
      this.setState({
        rejectReason,
      });
    }

    this._hideLoading();
  };

  _getPrimaryProcedureOwnerStepItemFailed = () => {
    this._alertError("Get Primary Procedure Owner Step Item Failed");
  };

  _getFlowDataSuccess = (result: any, param: any) => {
    const { procedureStepStatus } = result;
    let mergePayloadMap = undefined;

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: procedureStepStatus === "Complete",
      isShareTaskProcess: false,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      ApproveChangePPOStepService.getProcedureOwnerStepKey = () =>
        CompleteStepBusinessType.procedureOwner;
      ApproveChangePPOStepService.getPMPExcludedStepKey = () =>
        CompleteStepBusinessType.pmpExcluded;

      mergePayloadMap = StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.procedureOwner.settingKey,
        CompleteStepBusinessType.pmpExcluded.settingKey,
      ]);
    }

    ApproveChangePPOService.getPrimaryProcedureOwnerStepItem(
      param,
      (response: any) => this._getPrimaryProcedureOwnerStepItemSuccess(response, result),
      this._getPrimaryProcedureOwnerStepItemFailed,
      undefined,
      {
        ...mergePayloadMap,
        ...StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey]),
      }
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get PPO Flow Data Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };

    ApproveChangePPOService.getFlowStepData(
      param,
      (response: any) => this._getFlowDataSuccess(response, param),
      this._getFlowDataFailed
    );
  };

  closePage = () => {
    this.route("/ToDoList");
  };

  componentDidMount() {
    this._showLoading();
    this.getFlowData();
  }

  render() {
    const {
      loading,
      pageType,
      isApprovedCompletedPage,
      isSubmittedCompletedPage,
      isReturnedCompletedPage,
      isRejectedCompletedPage,
      shareTask,
      pageHeadState,
      procedureInfoState,
      rejectReason,
      procedureFileData,
      supportingFileData,
      jbProcedureSavedIn,
      taskInformationData,
      stepItemData,
    } = this.state;
    const procedureInformationData = {
      pageHeadState,
      procedureInfoState,
      rejectReason,
    };

    return (
      // @ts-ignore
      <NormalSpin spinning={loading} size="large" zIndex={1500}>
        {/* @ts-ignore */}
        {pageType === this.pageTypeEnums.isApprovePending && (
          // @ts-ignore
          <ApprovePPOPending
            primaryProcedureOwnerStepItem={this.state.primaryProcedureOwnerStepItem}
            procedureTaskId={(this as any).taskID}
            procedureID={(this as any).procedureID}
            procedureStepID={(this as any).procedureStepID}
            _showLoading={this._showLoading}
            _hideLoading={this._hideLoading}
            closePage={this.closePage}
            shareTask={shareTask}
            procedureInformationData={procedureInformationData}
            procedureFileData={procedureFileData}
            supportingTableData={supportingFileData}
            jbProcedureSavedIn={jbProcedureSavedIn}
            taskInformationData={taskInformationData}
            stepItemData={stepItemData}
            setProcedureFileData={this.setProcedureFileData}
            setSupportingFileData={this.setSupportingFileData}
            setTaskInfoData={this.setTaskInfoData}
            setProcedureInfoData={this.setProcedureInfoData}
            setShareTaskData={this.setShareTaskData}
          />
        )}
        {/* @ts-ignore */}
        {pageType === this.pageTypeEnums.isApproveCompleted && (
          // @ts-ignore
          <ApprovePPOCompleted
            primaryProcedureOwnerStepItem={this.state.primaryProcedureOwnerStepItem}
            procedureTaskId={(this as any).taskID}
            procedureID={(this as any).procedureID}
            procedureStepID={(this as any).procedureStepID}
            _showLoading={this._showLoading}
            closePage={this.closePage}
            isApprovedCompletedPage={isApprovedCompletedPage}
            isSubmittedCompletedPage={isSubmittedCompletedPage}
            isReturnedCompletedPage={isReturnedCompletedPage}
            isRejectedCompletedPage={isRejectedCompletedPage}
            shareTask={shareTask}
            procedureInformationData={procedureInformationData}
            procedureFileData={procedureFileData}
            supportingTableData={supportingFileData}
            jbProcedureSavedIn={jbProcedureSavedIn}
            taskInformationData={taskInformationData}
            setProcedureFileData={this.setProcedureFileData}
            setSupportingFileData={this.setSupportingFileData}
            setTaskInfoData={this.setTaskInfoData}
            setProcedureInfoData={this.setProcedureInfoData}
            setShareTaskData={this.setShareTaskData}
          />
        )}
        {/* @ts-ignore */}
        {pageType === this.pageTypeEnums.isRevisePending && (
          // @ts-ignore
          <ReviseChangePPOPending
            primaryProcedureOwnerStepItem={this.state.primaryProcedureOwnerStepItem}
            procedureTaskId={(this as any).taskID}
            procedureID={(this as any).procedureID}
            procedureStepID={(this as any).procedureStepID}
            _showLoading={this._showLoading}
            _hideLoading={this._hideLoading}
            closePage={this.closePage}
            shareTask={shareTask}
            procedureInformationData={procedureInformationData}
            procedureFileData={procedureFileData}
            supportingTableData={supportingFileData}
            jbProcedureSavedIn={jbProcedureSavedIn}
            taskInformationData={taskInformationData}
            setProcedureFileData={this.setProcedureFileData}
            setSupportingFileData={this.setSupportingFileData}
            setTaskInfoData={this.setTaskInfoData}
            setProcedureInfoData={this.setProcedureInfoData}
            setShareTaskData={this.setShareTaskData}
          />
        )}
        {/* @ts-ignore */}
        {pageType === this.pageTypeEnums.isReviseCompleted && (
          // @ts-ignore
          <ReviseChangePPOCompleted
            primaryProcedureOwnerStepItem={this.state.primaryProcedureOwnerStepItem}
            procedureTaskId={(this as any).taskID}
            procedureID={(this as any).procedureID}
            procedureStepID={(this as any).procedureStepID}
            _showLoading={this._showLoading}
            closePage={this.closePage}
            shareTask={shareTask}
            procedureInformationData={procedureInformationData}
            procedureFileData={procedureFileData}
            supportingTableData={supportingFileData}
            jbProcedureSavedIn={jbProcedureSavedIn}
            taskInformationData={taskInformationData}
            setProcedureFileData={this.setProcedureFileData}
            setSupportingFileData={this.setSupportingFileData}
            setTaskInfoData={this.setTaskInfoData}
            setProcedureInfoData={this.setProcedureInfoData}
            setShareTaskData={this.setShareTaskData}
          />
        )}
      </NormalSpin>
    );
  }
}
